import { ImagesSubComponent } from '../images.sub.component';

export class VideoLinkSubComponent extends ImagesSubComponent {
    public rootSelector = '.js_pdp_video-link';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        this.registerClickHandler();
        this.trackView({
            product_Video: 'view',
        });
    }

    private registerClickHandler(): void {
        const videoLinkElements: NodeList = document.body.querySelectorAll('.js_pdp_video-link');

        for (let i = 0; i < videoLinkElements.length; ++i) {
            videoLinkElements[i].addEventListener(
                'click',
                () => VideoLinkSubComponent.handleVideoLinkClick(videoLinkElements[i] as HTMLElement),
                false
            );
        }

        // videoLinkElement.addEventListener('click', () => VideoLinkSubComponent.handleVideoLinkClick(videoLinkElement), false);
    }

    private static handleVideoLinkClick(linkElement: HTMLElement) {
        o_global.eventQBus.emit('ft5.pdp-video.init', { assetKey: linkElement.dataset.assetKey });
    }

    protected onImageChanged(): void {
        return;
    }
}
